import React from 'react';

import './Organisation.css';
import './Organisation.mobile.css';


/* ============================================================
   DONNÉES
   ============================================================ */

const SYSTEMES_OPERATIONNELS = [
    {
        id: 'strategie',
        categorie: 'STRATÉGIE',
        titre: 'Gestion des priorités & ROI',
        description:
            "Analyse impitoyable du backlog. Je ne me contente pas de 'faire des tâches' : j'identifie les actions à fort impact business pour garantir que chaque heure facturée génère une valeur mesurable.",
        span: 'large'
    },
    {
        id: 'autonomie',
        categorie: 'AUTONOMIE',
        titre: 'Travail en autonomie complète',
        description:
            "Une fois le cadre défini, j'opère sans supervision constante. Je prends les décisions techniques nécessaires pour débloquer les situations complexes tout en restant aligné sur vos objectifs.",
        span: 'single'
    },
    {
        id: 'flux',
        categorie: 'FLUX',
        titre: 'Suivi de projets & Transparence',
        description:
            "Zéro effet tunnel. Utilisation de tableaux de bord partagés pour une visibilité totale sur l'avancement, les risques identifiés et les solutions proposées en temps réel.",
        span: 'single'
    },
    {
        id: 'delivery',
        categorie: 'DELIVERY',
        titre: 'Respect des délais & Engagement',
        description:
            "Mes estimations ne sont pas des suppositions. Elles reposent sur une analyse de complexité rigoureuse, garantissant des livraisons ponctuelles et une fiabilité totale.",
        span: 'double'
    },
    {
        id: 'knowledge',
        categorie: 'KNOWLEDGE',
        titre: 'Documentation & Transmission',
        description:
            "L'organisation ne s'arrête pas au code. Je livre des bases de connaissances structurées et une documentation exhaustive pour assurer la pérennité de vos systèmes.",
        span: 'double'
    }
];


/* ============================================================
   CARTE SYSTÈME
   ============================================================ */

const CarteSysteme = ({
    categorie,
    titre,
    description,
    span
}) => {

    return (

        <article
            className={`carte-systeme carte-${span}`}
            aria-label={`${categorie} — ${titre}`}
        >

            <header className="carte-header">

                <span
                    className="badge-categorie"
                    aria-label={`Catégorie : ${categorie}`}
                >
                    {categorie}
                </span>

            </header>


            <div className="carte-contenu">

                <h2 className="carte-titre">
                    {titre}
                </h2>


                <p className="carte-description">
                    {description}
                </p>

            </div>


            <footer
                className="carte-footer"
                aria-hidden="true"
            >
                <div className="ligne-decorative" />
            </footer>

        </article>

    );
};


/* ============================================================
   ORGANISATION
   ============================================================ */

const Organisation = () => {

    return (

        <section
            className="organisation-operationnelle"
            aria-labelledby="titre-organisation"
        >

            <div className="conteneur-systeme">

                <header className="systeme-header">

                    <div className="header-gauche">

                        <h1
                            id="titre-organisation"
                            className="titre-systeme"
                        >

                            <span className="titre-systeme-ligne titre-systeme-ligne-principale">
                                Organisation
                            </span>

                            <span className="titre-systeme-ligne titre-systeme-ligne-accent">
                                Opérationnelle
                            </span>

                        </h1>

                    </div>


                    <div className="header-droite">

                        <div
                            className="indicateur-statut"
                            role="status"
                            aria-live="polite"
                        >

                            <span
                                className="point-statut"
                                aria-hidden="true"
                            />

                            <span className="texte-statut">
                                PROTOCOLE ACTIF
                            </span>

                        </div>

                    </div>

                </header>


                <div
                    className="grille-systemes"
                    role="region"
                    aria-roledescription="carrousel"
                    aria-label="Systèmes organisationnels"
                >

                    {SYSTEMES_OPERATIONNELS.map(
                        (systeme) => (

                            <CarteSysteme
                                key={systeme.id}
                                categorie={systeme.categorie}
                                titre={systeme.titre}
                                description={systeme.description}
                                span={systeme.span}
                            />

                        )
                    )}

                </div>


                <footer className="systeme-footer">

                    <span className="footer-commentaire">
                        // SYSTÈMES CRITIQUES - APPROCHE MÉTHODIQUE
                    </span>

                    <span className="footer-reference">
                        REF: 88-092/ORG
                    </span>

                </footer>

            </div>

        </section>

    );
};


export default Organisation;